/** Пресеты задержки между кадрами time-lapse (мс). */
export const HISTORY_PLAYBACK_DELAYS_MS = [400, 800, 1500] as const;

export type HistoryPlaybackDelayMs = (typeof HISTORY_PLAYBACK_DELAYS_MS)[number];

export type HistoryPlaybackPhase = "idle" | "playing" | "paused";

export function canStartHistoryPlayback(eventCount: number): boolean {
  return eventCount > 0;
}

/**
 * Индекс кадра при старте Play.
 * Live (`null`) → 0; уже на последнем → с начала (0); иначе текущий.
 */
export function playbackStartIndex(
  currentIndex: number | null,
  eventCount: number,
): number | null {
  if (!canStartHistoryPlayback(eventCount)) return null;
  if (currentIndex == null) return 0;
  if (currentIndex < 0) return 0;
  if (currentIndex >= eventCount - 1) return 0;
  return currentIndex;
}

/**
 * Следующий кадр во время Play.
 * `ended` — достигли последнего события (остаёмся на нём, Pause снаружи).
 */
export function advancePlaybackIndex(
  currentIndex: number,
  eventCount: number,
): { index: number; ended: boolean } {
  if (eventCount <= 0) {
    return { index: currentIndex, ended: true };
  }
  const last = eventCount - 1;
  if (currentIndex >= last) {
    return { index: last, ended: true };
  }
  const next = currentIndex + 1;
  return { index: next, ended: next >= last };
}
